import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import PageUi from 'kts-platform-frame/display/components/PageUi';
import { Table, message, Row, Button, Icon, Tag, Popconfirm, Alert } from 'antd';
import Field from 'kts-scaffold-framework/utils/doc/Field';
import { history } from 'kts-platform-frame/routes';
import { outputApi } from 'src/api';
import UIRefuse from './UI.Refuse';
import UIListFilter from './UI.List.Filter';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    companyId?: string;
    companyName?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    ban: string;
    fresh: string;
    accept: string;
    create: string;
}

/**
 * 模块状态
 */
export class UIListtState {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    companyId: state.user.currentcompanyId,
    companyName: state.user.userInfo.companyName
}))
export default class UIListt extends UIBasic<IProps, ModulesState, any> {
    public spanCss = { cursor: "pointer" };
    public columns = [
        {
            title: "单号",
            width: 150,
            dataIndex: "bizNoticeId",
        },
        {
            title: "购方名称",
            width: 150,
            dataIndex: "buyerName"
        },
        {
            title: "创建日期",
            dataIndex: "createTime",
            width: 115,
            render: text => Field.formatDate(text)
        },
        {
            title: "金额",
            dataIndex: "amountWithoutTax",
            render: text => Field.formatMoney(text.toFixed(2))
        },
        {
            title: "税额",
            dataIndex: "amountTax",
            render: text => Field.formatMoney(text.toFixed(2))
        },
        {
            title: "价税合计",
            dataIndex: "amountSum",
            render: text => Field.formatMoney(text.toFixed(2))
        },
        {
            title: "状态",
            dataIndex: "makeInvoiceState",
            width: 140,
            render: (text, record) => {
                return (
                    <span>
                        {text === 1 && <Tag color='green'>已开票</Tag>}
                        {record.noticeBillState === 'CREATED' && <Tag color='green'>创建</Tag>}
                        {record.noticeBillState === 'SENDED' && <Tag color='green'>已送达</Tag>}
                        {record.noticeBillState === 'ACCEPTED' && <Tag color='green'>接受</Tag>}
                        {record.noticeBillState === 'REFUSED' && <Tag color='red'>拒绝</Tag>}
                        {record.noticeBillState === 'INVALID' && <Tag color='orange'>作废</Tag>}
                    </span>
                );
            }
        },
        {
            title: '操作',
            width: 145,
            dataIndex: 'noticeBillState',
            render: (text, record) => {
                return (
                    <div className="text-right">
                        {
                            //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.GET_notice_output_id) &&
                            <span style={this.spanCss} onClick={() => { this.onDetail(record); }}>详情 </span>
                        }
                        {text === 'SENDED' &&
                            <span>
                                {
                                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchAccept) &&
                                    <span style={this.spanCss} onClick={() => { this.onAccept(record); }}>| 接受 </span>
                                }
                                {
                                    // Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchRefuse) &&
                                    <span style={this.spanCss} onClick={() => { this.onReject(record); }}>| 拒绝</span>
                                }
                            </span>
                        }
                        {text === 'REFUSED' &&
                            <span>
                                {
                                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchAccept) &&
                                    <span style={this.spanCss} onClick={() => { this.onAccept(record); }}>| 接受 </span>
                                }
                            </span>}
                        {(text === 'ACCEPTED' && record.makeInvoiceState === 0) &&
                            <span>
                                {
                                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchMakeInvoice) &&
                                    <span style={this.spanCss} onClick={() => { this.onMakeInvoice(record); }}>| 开票 </span>
                                }
                            </span>
                        }
                        {record.makeInvoiceState === 1 &&
                            <Popconfirm
                                title="取消开票将会清除当前结算单所有开票记录！！"
                                placement="topRight"
                                onConfirm={() => this.onDisMakeInvoice(record)}
                            >
                                {
                                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_output_batchCancelInvoice) &&
                                    <span style={this.spanCss}>| 取消开票</span>
                                }
                            </Popconfirm>

                        }
                    </div>
                );
            }
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            companyId: this.props.companyId,
            companyName: this.props.companyName,
            showModal: false,
            message: '',
            refushArray: null,
        };
    }
    addAlert = () => {
        return (
            <Alert
                message={this.state.message}
                type="warning"
                closable={true}
                className="mb10"
                style={{ height: 70, overflowY: 'scroll' }}
                onClose={() => { this.setState({ show: false }); }}
            />
        );
    }
    //取消开票
    onDisMakeInvoice = record => {
        let data = [record.noticeId];
        outputApi.outputCancel(this, data).then((response: any) => {
            const res = response.res;
            if (res) {
                message.success('操作成功');
                this.getList();
            }

        });
    }
    onDetail = record => {
        history.push({ pathname: 'OutputSettlement/detail', search: `noticeId=${record.noticeId}` });
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.companyId && nextProps.companyId !== this.props.companyId) {
            this.setState({
                companyId: nextProps.companyId,
                companyName: nextProps.companyName
            }, () => { this.getList(); });
        } else if (nextProps.ban !== this.props.ban) {
            //父级批量禁用按钮触发自组件函数
            this.onBanHandler();
        } else if (nextProps.accept !== this.props.accept) {
            this.onActiveHandler();
        } else if (nextProps.fresh !== this.props.fresh) {
            this.onFreshHandler();
        } else if (nextProps.create !== this.props.create) {
            this.onOpenHandler();
        }
    }
    //单个开票
    onMakeInvoice = record => {
        let arr = [record];
        this.doMakeInvoices(arr);
    }
    //批量开票筛选数据
    onOpenHandler = () => {
        const { selectedRows } = this.modulesState;
        if (selectedRows.length === 0) {
            message.warn('请勾选结算单');
            return;
        }
        let arr = selectedRows.filter(
            (value) => {
                return (value.makeInvoiceState === 0 && value.noticeBillState === 'ACCEPTED');
            }
        );
        if (arr.length === 0) {
            message.warn('勾选记录不符合要求');
            return;
        } else if (arr.length < selectedRows.length) {
            this.doMakeInvoices(arr, '操作成功，部分记录为已开票，请检查');
            return;
        }
        this.doMakeInvoices(arr);
    }
    doMakeInvoices = (arr, str: string = '') => {
        let noticeArray = [];
        for (let i = 0; i < arr.length; i++) {
            noticeArray.push(arr[i].noticeId);
        }
        outputApi.outputCreate(this, noticeArray).then((response: any) => {
            const res = response.res;
            let insert = '';
            if (res && res.length > 0) {
                insert = res.map((item, index) => {
                    return <div key={index}>{item.msg}</div>;
                });

            } else if (res && res.length === 0) {
                insert = '提交成功';
            }
            this.setState({
                message: insert,
                show: true,
            }, () => { this.getList(); });

        });
    }
    onReject = record => {
        let arr = [record];
        this.openModal(arr);
    }
    //批量拒绝筛选可用数据
    onBanHandler = () => {
        const { selectedRows } = this.modulesState;
        if (selectedRows.length === 0) {
            message.warn('请勾选结算单');
            return;
        }
        let arr = selectedRows.filter(
            (value) => {
                return value.noticeBillState === 'SENDED';
            }
        );
        if (arr.length === 0) {
            message.warn('所有记录无法拒绝，请检查');
            return;
        } else if (arr.length < selectedRows.length) {
            this.openModal(arr, '所选记录部分为已拒绝，请检查');
            return;
        }
        this.openModal(arr);
    }
    refush = (str) => {
        this.setState({
            showModal: false
        });
        const { refushArray } = this.state;
        let noticeArray = { noticeIdList: [], refusedReason: '' };
        for (let i = 0; i < refushArray.length; i++) {
            noticeArray.noticeIdList.push(refushArray[i].noticeId);
        }
        noticeArray.refusedReason = str;
        this.doRefuse(noticeArray);
    }
    //关闭拒绝窗口
    onCloseModal = () => {
        this.setState({
            showModal: false
        });
    }
    openModal = (arr, modalContent?: string) => {
        this.setState({
            showModal: true,
            refushArray: arr,
            content: modalContent
        });
    }
    //批量拒绝
    doRefuse = (arr) => {
        outputApi.outputRefuse(this, arr).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.getList();
                }
            }
        });
    }
    onAccept = record => {
        let arr = [record];
        this.doAccept(arr);
    }
    //批量接受筛选可用数据
    onActiveHandler = () => {
        const { selectedRows } = this.modulesState;
        if (selectedRows.length === 0) {
            message.warn('请勾选结算单');
            return;
        }
        let arr = selectedRows.filter(
            (value) => {
                return value.noticeBillState === 'REFUSED' || value.noticeBillState === 'SENDED';
            }
        );
        if (arr.length === 0) {
            message.warn('所有记录不符合要求，请检查');
            return;
        } else if (arr.length < selectedRows.length) {
            this.doAccept(arr, '操作成功，部分记录为已接受，请检查');
            return;
        }
        this.doAccept(arr);
    }
    //批量接受
    doAccept = (arr, str?: string) => {
        let noticeArray = [];
        for (let i = 0; i < arr.length; i++) {
            noticeArray.push(arr[i].noticeId);
        }
        outputApi.outputAccept(this, noticeArray).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    message.success(str || '操作成功');
                    this.modulesState.pageNum=1;
                    this.setModulesState().then(() => { this.getList(); });
                }
            }
        });
    }
    onChange = (selectedRowKeys, selectedRows) => {
        this.modulesState.selectedRows = selectedRows;
        this.modulesState.selectedRowKeys = selectedRowKeys;
        this.setModulesState();
    }
    onFreshHandler = () => {
        this.getList();
    }
    toggle = () => {
        const { expand } = this.state;
        this.setState({ expand: !expand });
    }
    componentDidMount() {
        if (this.state.companyId) {
            this.getList();
        }
    }
    mapListToPage = (page) => {
        let { query } = this.state;
        query = {
            ...query,
            page
        };
        this.modulesState.pageNum = page;
        this.setModulesState().then(() => { this.getList(); });
        // browserHistory.push({ pathname: '/index/OutputSettlement', query: query })
        // this.setState({
        //     pageNum: page,
        //     query: query
        // }, () => { this.getList(); });

    }
    onSizeChange = (current, pageSize) => {
        this.modulesState.pageNum = current;
        this.modulesState.pageSize = pageSize;
        this.setModulesState().then(() => { this.getList(); });

        // this.setState({
        //     pageSize: pageSize,
        //     pageNum: current,
        // }, () => this.getList());
    }
    getList = () => {
        ModulesAction.getData();
    }
    clearFields = () => {
        this.setState({
            fields: null
        });
    }
    handleFormChange = (changedFields) => {
        this.setState({
            fields: { ...this.state.fields, ...changedFields },
        });
    }

    disableCheck = (record) => ({
        disabled: record.noticeBillState === 'INVALID'
    })
    render() {
        let { list, selectedRowKeys } = this.modulesState;
        let { companyName } = this.state;
        const dataSource = list && list.items.map((item, index) => {
            return {
                ...item,
                index,
            };
        });

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onChange,
            getCheckboxProps: this.disableCheck,

        };
        const columns = this.columns;
        return (
            <div>
                <Row>
                    <span style={{ marginRight: 8 }}>销方名称:</span>
                    <span>{companyName}</span>
                    <div className="text-right pull-right">
                        <Button className="ml-10 mb-10" onClick={this.toggle}>
                            筛选 <Icon type={this.state.expand ? "up" : "down"} />
                        </Button>
                    </div>
                </Row>
                {
                    this.state.show && this.addAlert()
                }
                <div style={{ display: this.state.expand ? "block" : "none" }}>
                    <UIListFilter />
                </div>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    rowKey='index'
                    rowSelection={rowSelection}
                    pagination={false}
                />
                {
                    list &&
                    <PageUi
                        pageSize={this.state.pageSize}
                        data={list.pageMeta}
                        onChange={this.mapListToPage}
                        onShowSizeChange={this.onSizeChange}
                        hideTotal={true}
                    />
                }
                {
                    this.state.showModal &&
                    <UIRefuse
                        onCloseModal={this.onCloseModal}
                        refush={this.refush}
                    />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.List.tsx